var React = require('react');

function DotsHorisontal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.556 21c1.687 0 3.055 1.343 3.055 3s-1.368 3-3.055 3C8.868 27 7.5 25.657 7.5 24s1.368-3 3.056-3zM24 21c1.688 0 3.056 1.343 3.056 3S25.687 27 24 27c-1.688 0-3.056-1.343-3.056-3s1.369-3 3.056-3zm13.444 0c1.688 0 3.056 1.343 3.056 3s-1.368 3-3.056 3c-1.687 0-3.055-1.343-3.055-3s1.368-3 3.055-3z"}));
}

DotsHorisontal.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = DotsHorisontal;

DotsHorisontal.default = DotsHorisontal;
